import type { TranslationDict } from '../en';

const sk: TranslationDict = {
  'header.buy': 'Kúpiť',
  'header.sell': 'Predať',
  'spend.label': 'Zaplatíte',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',
  'receive.label': 'Dostanete',
  'payment.label': 'Spôsob platby',
  'payment.select': 'Vybrať',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'Pre tento pár nie sú dostupné žiadne platobné metódy',
  'wallet.label': 'Adresa prijímacej peňaženky',
  'wallet.placeholderBuy': 'Zadajte svoju prijímaciu adresu',
  'wallet.placeholderSell': 'Zadajte svoju odosielaciu adresu',
  'wallet.validating': 'Overovanie adresy...',
  'wallet.invalid': 'Zadajte platnú adresu peňaženky',
  'wallet.invalidServer': 'Neplatná adresa peňaženky',
  'cta.buy': 'Kúpiť {crypto}',
  'cta.sell': 'Predať {crypto}',
  'cta.gettingPrice': 'Hľadáme najlepšiu cenu...',
  'cta.processing': 'Spracovávam...',
  'footer.poweredBy': 'Pohonné hmoty od ',
  'footer.brand': 'NowRamp',
  'rate.title': 'Prehľad kurzu',
  'rate.close': 'Zavrieť',
  'rate.updatesIn': 'Kurz sa aktualizuje za 00:{seconds}',
  'rate.noQuote': 'Žiadna ponuka nie je k dispozícii',
  'rate.exchangeRate': 'Výmenný kurz',
  'rate.processingFee': 'Poplatok za spracovanie',
  'rate.networkFee': 'Sieťový poplatok',
  'rate.provider': 'Poskytovateľ',
  'toast.orderCreated': 'Objednávka vytvorená',
  'toast.redirecting': 'Presmerovanie na platbu...',
  'toast.orderFailed': 'Objednávka zlyhala',
  'toast.couldNotCreate': 'Objednávku sa nepodarilo vytvoriť',
  'toast.quoteError': 'Chyba ponuky',
  'toast.noProviders': 'Žiadni poskytovatelia',
  'toast.somethingWrong': 'Niečo sa pokazilo',
  'error.amountZero': 'Suma musí byť väčšia ako 0',
  'error.minAmountFiat': 'Minimálna suma je {min} {currency}',
  'error.minAmountCrypto': 'Minimálna suma je {min} {currency}',
  'error.noProviders': 'Pre túto kombináciu nie sú dostupní žiadni poskytovatelia',
  'error.currencyUnavailableBuy': 'Táto mena nie je dostupná pre nákupné objednávky',
  'error.currencyUnavailableSell': 'Táto mena nie je dostupná pre predajné objednávky',
  'parity.info': 'Bude vám účtované za {receiveAmount} {crypto}, zvyšok do {spendAmount} {fiat} bude pripísaný na váš účet {partner}',
  'redirect.secureBadge': 'Bezpečná platba',
  'redirect.title': 'Pokračovať v platbe',
  'redirect.description': 'Budete presmerovaní na {gateway} na dokončenie platby.',
  'redirect.countdown': 'Presmerovanie za {seconds}...',
  'redirect.openTab': 'Otvoriť ACH v novej karte',
  'redirect.cancel': 'Zrušiť',
  'checkout.noOrder': 'Objednávka nenájdená',
  'checkout.goBack': 'Späť',
  'checkout.expired': 'Platba vypršala',
  'checkout.expiredDesc': 'Relácia vypršala. Skúste to prosím znova.',
  'checkout.startOver': 'Začať odznova',
  'checkout.cancel': 'Zrušiť',
  'checkout.loading': 'Načítavam platbu...',
  'checkout.iframeTitle': 'Platba poskytovateľa',
  'checkout.widgetTitle': 'Platobná pokladňa',
  'checkout.unknownMethod': 'Neznáma platobná metóda',
  'processing.default': 'Spracovávam vašu objednávku...',
  'processing.pending': 'Čakám na potvrdenie platby...',
  'processing.active': 'Spracovávam vašu transakciu...',
  'processing.generic': 'Spracovávam...',
  'processing.checkingStatus': 'Kontrolujem stav...',
  'processing.orderId': 'ID objednávky',
  'processing.provider': 'Poskytovateľ',
  'processing.amount': 'Suma',
  'processing.receiving': 'Príjem',
  'processing.network': 'Sieť',
  'processing.toAddress': 'Na adresu',
  'processing.usuallyMinutes': 'Zvyčajne to trvá niekoľko minút.',
  'processing.safeToClose': 'Túto stránku môžete bezpečne zavrieť — po dokončení vám pošleme e-mail.',
  'complete.buyTitle': 'Nákup dokončený!',
  'complete.sellTitle': 'Predaj dokončený!',
  'complete.buyDesc': 'Vaše {crypto} boli odoslané do vašej peňaženky.',
  'complete.sellDesc': 'Vaša výplata v {fiat} sa spracováva.',
  'complete.amountBuy': 'Prijatá suma',
  'complete.amountSell': 'Predaná suma',
  'complete.paidBuy': 'Zaplatená suma',
  'complete.paidSell': 'Suma výplaty',
  'complete.network': 'Sieť',
  'complete.wallet': 'Peňaženka',
  'complete.transaction': 'Transakcia',
  'complete.provider': 'Poskytovateľ',
  'complete.orderId': 'ID objednávky',
  'complete.completed': 'Dokončené',
  'complete.viewExplorer': 'Zobraziť v Exploreri',
  'complete.done': 'Hotovo',
  'errorStep.failed': 'Platba zlyhala',
  'errorStep.cancelled': 'Objednávka zrušená',
  'errorStep.expired': 'Objednávka vypršala',
  'errorStep.refunded': 'Objednávka vrátená',
  'errorStep.unknown': 'Niečo sa pokazilo',
  'errorStep.failedBuy': 'Vašu platbu sa nepodarilo spracovať. Skúste to znova alebo použite iný spôsob platby.',
  'errorStep.failedSell': 'Váš predaj sa nepodarilo spracovať. Skúste to prosím znova.',
  'errorStep.cancelledBuy': 'Vaša objednávka bola zrušená. Žiadna platba nebola spracovaná.',
  'errorStep.cancelledSell': 'Váš predaj bol zrušený. Žiadne krypto nebolo prevedené.',
  'errorStep.expiredBuy': 'Vaša objednávka vypršala. Zahajte prosím nový nákup.',
  'errorStep.expiredSell': 'Vaša objednávka vypršala. Zahajte prosím nový predaj.',
  'errorStep.refundedBuy': 'Vaša platba bola vrátená. Prostriedky by sa mali objaviť na vašom účte do 5–10 pracovných dní.',
  'errorStep.refundedSell': 'Vaše krypto bolo vrátené. Prostriedky by sa mali čoskoro objaviť vo vašej peňaženke.',
  'errorStep.genericDesc': 'Nastala neočakávaná chyba. Skúste to prosím znova.',
  'errorStep.orderId': 'ID objednávky',
  'errorStep.tryAgain': 'Skúsiť znova',
  'errorStep.startOver': 'Začať odznova',
  'errorStep.return': 'Späť',
  'errorStep.needHelp': 'Potrebujete pomoc? Kontaktujte ',
  'errorStep.reference': 'Referencia: {orderId}',
  'confirm.buyTitle': 'Potvrdiť nákup',
  'confirm.sellTitle': 'Potvrdiť predaj',
  'confirm.loading': 'Načítavam...',
  'confirm.provider': 'Poskytovateľ',
  'confirm.youPay': 'Zaplatíte',
  'confirm.youSell': 'Predávate',
  'confirm.youReceive': 'Dostanete',
  'confirm.wallet': 'Peňaženka',
  'confirm.network': 'Sieť',
  'confirm.refundAddress': 'Adresa pre vrátenie',
  'confirm.parityNote': 'Účtovaná suma od poskytovateľa sa môže líšiť. Zvyšok do {amount} {crypto} bude pripísaný na váš účet {partner}.',
  'confirm.processing': 'Spracovávam...',
  'confirm.confirmPay': 'Potvrdiť a zaplatiť',
  'confirm.confirmSell': 'Potvrdiť a predať',
  'confirm.payout': 'Výplata v {currency}',
  'modal.selectFiat': 'Vyberte fiat menu',
  'modal.selectCrypto': 'Vyberte kryptomenu',
  'modal.choosePayment': 'Vyberte spôsob platby',
  'modal.selectCountry': 'Vyberte svoju krajinu',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'Obľúbené',
  'modal.recommended': 'Odporúčané',
  'modal.noCurrencies': 'Žiadne meny nenájdené',
  'modal.noPaymentMethods': 'Žiadne platobné metódy nenájdené',
  'modal.noCountries': 'Žiadne krajiny nenájdené',
  'modal.noLanguages': 'No languages found',
  'settings.location': 'Poloha',
  'settings.darkMode': 'Tmavý režim',
  'settings.privacy': 'Zásady ochrany súkromia',
  'settings.terms': 'Podmienky používania',
  'settings.language': 'Jazyk',
  // ─── Additional ───
  'modal.chooseRamp': 'Vybrať Ramp',
  'modal.bestPrice': 'Najlepšia cena',
  'modal.noQuotes': 'Pre túto požiadavku nie sú dostupné žiadne ponuky',
  'modal.noProvidersFound': 'Žiadni poskytovatelia nenájdení',
  'payment.unavailableFor': 'Žiadne platobné metódy nie sú dostupné pre {currency}',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'Vytvorenie objednávky zlyhalo',
  'errorStep.returnToMerchant': 'Späť k obchodníkovi',
  'confirm.cryptoOnNetwork': '{crypto} na {network}',
  'payment.name.card': 'Karta',
  'payment.name.bankTransfer': 'Bankový prevod',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default sk;
